import { Link, useNavigate } from "react-router";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import LockResetOutlinedIcon from "@mui/icons-material/LockResetOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import { ListItemIcon, ListItemText, MenuItem, Switch } from "@mui/material";
import { useAtom } from "jotai";
import { fabHiddenAtom } from "src/business-components/FabButton/FabButton.state";
import { captureFeature } from "src/utils/analytics";
import { appRoutes } from "src/utils/appRoutes/appRoutes";

interface TopbarUserActionsProps {
  onGenerateToken: () => void;
}

export default function TopbarUserActions({
  onGenerateToken,
}: TopbarUserActionsProps) {
  const navigate = useNavigate();
  const [fabHidden, setFabHidden] = useAtom(fabHiddenAtom);

  return (
    <>
      <MenuItem
        onClick={onGenerateToken}
        data-ph-capture-attribute-action="generate_agent_token"
      >
        <ListItemIcon>
          <VpnKeyOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Generate Token</ListItemText>
      </MenuItem>

      <MenuItem>
        <ListItemIcon>
          <LockResetOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <Link
          to="/change-password"
          className="no-underline! hover:text-inherit!"
          data-ph-capture-attribute-action="change_password"
        >
          <ListItemText>Change Password</ListItemText>
        </Link>
      </MenuItem>

      <MenuItem
        onClick={() => {
          const nextHidden = !fabHidden;
          setFabHidden(nextHidden);
          captureFeature("fab_visibility_toggle", { visible: !nextHidden });
        }}
        aria-label="Toggle help button"
        data-ph-capture-attribute-action="toggle_help_fab"
      >
        <ListItemIcon>
          <HelpOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Help & Feedback</ListItemText>
        <Switch
          edge="end"
          size="small"
          checked={!fabHidden}
          slotProps={{
            input: { readOnly: true, tabIndex: -1, "aria-hidden": true },
          }}
        />
      </MenuItem>

      <MenuItem
        onClick={() => navigate(appRoutes.logout.path)}
        data-ph-capture-attribute-action="logout"
      >
        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Logout</ListItemText>
      </MenuItem>
    </>
  );
}
